import API from '../api'
import postUrl from './paths'

export const createEnquiry = (enquiry, user, newAddressAdded = false) =>
	new Promise((resolve, reject) => {
		enquiry.created_by = user.user_id
		enquiry.created_at = new Date().getTime()
		API.post(postUrl.createEnquiry, enquiry, { newAddressAdded })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// Duplicate an enquiry — POST /enquiry/createDuplicateEnquiry?enquiryId=<id>.
// Resolves the API response (which carries the newly-created enquiry / its id).
export const createDuplicateEnquiry = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createDuplicateEnquiry, {}, { enquiryId })
			.then((response) => resolve(response.data))
			.catch((err) => reject(err))
	})

export const downloadEstimate = (enquiryId, data) =>
	new Promise((resolve, reject) => {
		API.post(
			postUrl.downloadEstimate,
			data,
			{ enquiryId },
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/pdf',
				},
			}
		)
			.then((response) => {
				resolve(response)
			})
			.catch((err) => reject(err))
	})

export const convertToOrder = (enquiryId, userId, orderDate, costMetrics) =>
	new Promise((resolve, reject) => {
		if (!orderDate) {
			orderDate = new Date().getTime()
		}
		API.post(postUrl.convertToOrder, costMetrics, { enquiryId, userId, orderDate }, { timeout: 1000 * 60 * 10 })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateEnquiryCostMetrics = (enquiryId, userId, costMetrics) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.updateEnquiryCostMetrics, costMetrics, { enquiryId, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const AddSiteManagerInEnquiry = (name, mobile, email, designation, enquiryId, userId, organisationId) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.addSiteManager, { name, mobile, email, designation, removeDefault: true }, { enquiryId, userId, organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const addUpdateEnquiryItemsApi = (enquiryId, enquiryItemList) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.addEnquiryItem, enquiryItemList, { enquiryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => {
				reject(err)
			})
	})
